
import SourceWrap from './source-wrap.vue'

const EXTRA_COUNT = 2

export default {
  components: {SourceWrap},
  props: {
    sources: {
      type: Array,
      default: () => []
    },
    colsCount: {
      type: Number,
      default: 5
    },
    showAll: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    extra_items(){
      if (this.sources.length <= this.colsCount) return []
      if (this.$responsive.mobile) return this.sources.toSpliced(0, this.colsCount - 1).toSpliced(EXTRA_COUNT - 1)
      return this.sources.toSpliced(0, this.colsCount - 1).toSpliced(EXTRA_COUNT)
    },
    rest_count(){
      const abs = this.colsCount - this.sources.length
      return abs < 0 ? Math.abs(abs) : 0
    },
    show_more(){
      return !!this.extra_items.length && !this.showAll
    },
  }
}
